import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Privacy: React.FC = () => {
  const { surfaceClass } = useTheme();

  return (
    <div className="pb-24 px-6 pt-6 max-w-3xl mx-auto animate-in slide-in-from-bottom-4 duration-500">
      
      <Link to="/" className="inline-flex items-center gap-2 opacity-50 hover:opacity-100 mb-8 transition-opacity">
          <ChevronLeft size={20} /> Back to Home
      </Link>

      <div className={`p-8 rounded-2xl border border-black/5 dark:border-white/5 shadow-sm ${surfaceClass}`}>
        <h1 className="font-serif text-3xl font-bold mb-2">Privacy Policy</h1>
        <p className="opacity-50 text-sm mb-8">Last updated: March 15, 2024</p>

        <div className="prose dark:prose-invert max-w-none text-sm leading-relaxed opacity-80 space-y-6">
            <p>
                Your privacy is important to us. This Privacy Policy explains how <strong>Readsy.link</strong> collects, uses, and protects your information.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">1. Information We Collect</h3>
            <p>
                <strong>Email Address:</strong> We collect your email address solely for the purpose of authentication (Magic Link) and account management. <br/>
                <strong>Reading Data:</strong> We store your reading progress, bookmarks, and statistics to provide synchronization across devices. <br/>
                <strong>Usage Data:</strong> We may collect anonymous analytics data (e.g., pages visited, time spent) to improve our service.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">2. How We Use Your Information</h3>
            <p>
                We use your information to:
                <ul className="list-disc pl-5 mt-2 space-y-1">
                    <li>Authenticate you and secure your account.</li>
                    <li>Sync your reading progress and bookmarks.</li>
                    <li>Send you important service updates (no spam).</li>
                    <li>Analyze usage trends to improve Readsy.</li>
                </ul>
            </p>

            <h3 className="font-bold text-lg text-brand-blue">3. Data Storage and Security</h3>
            <p>
                Your data is stored securely using industry-standard encryption. We do not sell, trade, or rent your personal identification information to others.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">4. Cookies</h3>
            <p>
                We use cookies and local storage to maintain your session and save your preferences (like theme and font size). You can control cookies through your browser settings, but disabling them may affect your ability to use Readsy.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">5. Third-Party Services</h3>
            <p>
                We may use trusted third-party services for hosting, analytics, and email delivery. These services have their own privacy policies and are compliant with data protection regulations.
            </p>

            <h3 className="font-bold text-lg text-brand-blue">6. Your Rights</h3>
            <p>
                You have the right to access, correct, or delete your personal information. If you wish to delete your account and all associated data, please contact us at <a href="mailto:hello@readsy.link" className="text-brand-blue underline">hello@readsy.link</a>.
            </p>
        </div>
      </div>
    </div>
  );
};